import statsRosette from '@propertypal/shared/src/resources/icons/property/stats-rosette.svg?url';
import { trackGaLink } from '@propertypal/shared/src/services/analytics';
import { Property } from '@propertypal/shared/src/types/property';
import { formatNumber } from '@propertypal/shared/src/utils/floatToCurrency';
import { getFormattedPrice } from '@propertypal/shared/src/utils/property';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import { MidHeading, Text } from '../typography';
import PromoteProperty from './PromoteProperty';
import { Container, InfoBar, LeftSide, RosetteContainer, RosetteText, ViewBox } from './PromotePropertyStats.style';

interface Props {
  property: Property;
}

const PromotePropertyStats: FunctionComponent<Props> = (props) => {
  const keyInfoStats = props.property.keyInfo?.filter((i) => i.group === 'ENGAGEMENT') || [];
  const theme = useTheme();
  const from = getFormattedPrice(props.property.stats?.ranking?.range?.from, '£');
  const to = getFormattedPrice(props.property.stats?.ranking?.range?.to, '£');

  if (!props.property.stats || (props.property.stats && props.property.stats.totalViews === '0')) {
    return <PromoteProperty property={props.property} />;
  }

  return (
    <Container>
      <LeftSide>
        <MidHeading fontSize={24}>
          <b>{formatNumber(props.property.stats?.totalViews)}</b> people have viewed your property
        </MidHeading>

        <Text>
          Upgrade your advert and get up to <b>50% more views</b>
        </Text>

        <ViewBox>
          <Text fontSize={14}>YOUR CURRENT VIEWS</Text>
          <InfoBar>
            {keyInfoStats.map((info) => (
              <div key={info.key}>
                <p>{info.name}</p>
                <h5>{formatNumber(info.text)}</h5>
              </div>
            ))}
          </InfoBar>
        </ViewBox>

        <Link
          href={`/prime?propertyId=${props.property.pathId}`}
          onClick={trackGaLink('prime_advert_click', 'PDP Ad', 'PDP')}
          prefetch={false}
        >
          <Button containerStyle={{ width: 240 }}>Get more views</Button>
        </Link>
      </LeftSide>

      {props.property.stats?.ranking && (
        <div>
          <RosetteContainer>
            <img src={statsRosette.src} width={statsRosette.width} height={statsRosette.height} alt="rosette" />
            <RosetteText>{props.property.stats.ranking.popularity}</RosetteText>
          </RosetteContainer>

          <Text align="center" autoMargin fontSize={20} maxWidth={220} mt={10} mb={10}>
            <span style={{ color: theme.primary }}>{props.property.stats.ranking.popularity}</span> most popular ranking
            today in <span style={{ color: theme.primary }}>{props.property.stats.ranking.term}</span>
          </Text>

          {props.property.stats.ranking.range && (
            <Text align="center" data-testid="rankingRangeText" color={theme.backgroundMid}>
              ({from}
              {!props.property.stats.ranking.range.max ? ` - ${to}` : ''}
              {props.property.stats.ranking.range.max ? '+' : ''})
            </Text>
          )}
        </div>
      )}
    </Container>
  );
};

export default PromotePropertyStats;
